import { convertMsToTimeString, getTimeDifference } from '@/utils/helpers';

export const getTimeDelayString = (dateTimeString: string | null, etaDelayEnd?: string | null) => {
  const end = etaDelayEnd ? new Date(etaDelayEnd) : new Date();
  if (!dateTimeString) {
    return null;
  }

  if (new Date(dateTimeString).getTime() < end.getTime()) {
    const timeDifference = getTimeDifference(new Date(dateTimeString), end);
    return `+${convertMsToTimeString(timeDifference.MILLISECONDS, 'short')}`;
  }

  return null;
};
